import { useEffect, useRef } from 'react';

// Injects a TradingView embed script exactly once per mounted container.
// Never removes the script in cleanup: a removed <script> still executes and
// TradingView's embed code crashes on `script.parentElement.querySelector`.
export const useTradingViewWidget = (src, config) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container || container.childElementCount > 0) return;

    const widgetDiv = document.createElement('div');
    widgetDiv.className = 'tradingview-widget-container__widget';
    widgetDiv.style.height = '100%';

    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.type = 'text/javascript';
    script.textContent = JSON.stringify(config);

    container.appendChild(widgetDiv);
    container.appendChild(script);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return containerRef;
};
